import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllLevelsTable from './components/AllLevelsTable';

function RankPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Level" />
      <ErrorBoundaries>
        <AllLevelsTable />
      </ErrorBoundaries>
    </>
  );
}

export default RankPage;
